import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Chart from 'analytics/components/Chart/Chart/Chart.container'
import ChartWrapper from 'shared/components/chart/Wrapper/Wrapper.component'
import Select from 'shared/components/form/Select/Select.component'

import { DateRangePicker } from 'react-dates'
import 'react-dates/initialize'

import styles from 'analytics/components/Sections/basic.module.scss'

import channelsList from 'shared/utils/channelsList'
import dateRangeList from 'shared/utils/chart/dateRangeList'
import { setTitleByEventName } from 'shared/utils/titles'


const setDateRangeTitle = (dateRange, customDateRange) => {
  if(dateRange === 'custom') {
    return customDateRange.startDate.format('MMM D') + ' to ' +
      customDateRange.endDate.format('MMM D')
  }

  return dateRange
}

const tableDataMapHandler = item => [
  setTitleByEventName(item['thread_events.eventname']),
  item['thread_events.count']
]

const Users = ({
  chartType,
  granularity,
  dateRange,
  customDateRange,
  channelNameToFilter,
  onChangeChartType,
  onChangeGranularity,
  onMoveCustomDateRange,
  onChangeSelectField,
  onChangeCustomDateRange
}) => {
  const [ focusedInput, updateFocusedInput ] = useState(null)

  return (
    <main className={styles.main}>

      <header className={styles.header}>

        <span className={styles.headerTitle}>
          Audience

          <span className={styles.headerDateRangeTitle}>
            {`/ ${setDateRangeTitle(dateRange, customDateRange)}`}
          </span>
        </span>

        <div className={styles.selectWrapper}>
          <Select
            data={[
              { name: 'All Channels', code: 'all' },
              ...channelsList
            ]}
            value={channelNameToFilter}
            onChange={onChangeSelectField('channelNameToFilter')}
          />

          <Select
            data={dateRangeList}
            value={dateRange}
            onChange={onChangeSelectField('dateRange')}
          />

          {
            dateRange === 'custom' && (
              <div className={styles.datePickerWrapper}>
                <DateRangePicker
                  startDate={customDateRange.startDate} // momentPropTypes.momentObj or null,
                  startDateId="startDate" // PropTypes.string.isRequired,
                  endDate={customDateRange.endDate} // momentPropTypes.momentObj or null,
                  endDateId="endDate" // PropTypes.string.isRequired,
                  onDatesChange={onChangeCustomDateRange} // PropTypes.func.isRequired,
                  focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={focusedInput => updateFocusedInput(focusedInput)}
                  small
                  isOutsideRange={() => false}
                />
              </div>
            )
          }
        </div>

      </header>

      <ChartWrapper>
        <Chart
          chartType={chartType}
          granularity={granularity}
          dateRange={dateRange}
          customDateRange={customDateRange}
          channelNameToFilter={channelNameToFilter}
          onChangeChartType={onChangeChartType}
          onChangeGranularity={onChangeGranularity}
          onMoveCustomDateRange={onMoveCustomDateRange}
          tableDataMapHandler={tableDataMapHandler}

          table='thread_events'
          timeDimension='time'
          measures={[ 'count' ]}
          dimensions={[ 'eventname' ]}
          filters={[ {
            'dimension': 'thread_events.eventname',
            'operator': 'equals',
            'values': [
              'USER_NEW',
              'USER_OLD'
            ]
          } ]}

          defaultChartType='bar'
          tooltipDimension='eventname'
          druid
        />
      </ChartWrapper>

    </main>
  )
}

Users.propTypes = {
  chartType: PropTypes.string.isRequired,
  granularity: PropTypes.string.isRequired,
  dateRange: PropTypes.string.isRequired,
  customDateRange: PropTypes.object.isRequired,
  channelNameToFilter: PropTypes.string.isRequired,
  onChangeChartType: PropTypes.func.isRequired,
  onChangeGranularity: PropTypes.func.isRequired,
  onMoveCustomDateRange: PropTypes.func.isRequired,
  onChangeSelectField: PropTypes.func.isRequired,
  onChangeCustomDateRange: PropTypes.func.isRequired
}

export default Users
